import React from "react";
import { motion } from "framer-motion";
import { Lightbulb, ArrowRight } from "lucide-react";
import ColyMascot from "@/components/ColyMascot";

const FeatureSuggest = () => (
  <section
    id="features"
    data-testid="feature-suggest-section"
    className="px-5 sm:px-6 pt-8 pb-16 sm:pt-12 sm:pb-20"
  >
    <div className="max-w-[1180px] mx-auto">
      <motion.a
        href="/support?topic=feature"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        whileHover={{ y: -3 }}
        data-testid="feature-suggest-card"
        className="group block relative bg-white border-2 border-coly-ink/5 rounded-[32px] p-8 sm:p-12 overflow-hidden"
        style={{ boxShadow: "0 6px 0 rgba(47,58,44,0.04), 0 30px 60px -30px rgba(47,58,44,0.15)" }}
      >
        {/* decorative blobs */}
        <div
          className="absolute -top-16 -right-10 w-[260px] h-[260px] rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(111,176,137,0.16), transparent 65%)", filter: "blur(14px)" }}
        />
        <div
          className="absolute -bottom-20 -left-12 w-[220px] h-[220px] rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(244,201,93,0.18), transparent 65%)", filter: "blur(14px)" }}
        />

        <div className="relative grid sm:grid-cols-[1fr_auto] items-center gap-8">
          <div>
            <span className="inline-flex items-center gap-1.5 bg-coly-yellow/30 border border-coly-yellow/60 rounded-full px-3 py-1 text-[11px] font-extrabold uppercase tracking-wider text-coly-yellow-deep">
              <Lightbulb className="w-3 h-3" />
              Features
            </span>
            <h2 className="mt-4 text-[28px] sm:text-[36px] lg:text-[42px] font-black m-0 tracking-[-1px] leading-[1.05]">
              Got a feature in mind?<br />
              <span className="text-coly-green-deep">We&apos;d love to hear it.</span>
            </h2>
            <p className="mt-4 text-coly-ink-soft text-[15px] sm:text-[17px] leading-[1.55] font-medium max-w-[560px]">
              If you feel a feature needs to be in the app, or something is missing —
              tell us under here. Every idea from a real gut warrior shapes what we build next.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 bg-coly-green text-white rounded-full px-5 py-3 font-extrabold text-[14px] sm:text-[15px] group-hover:gap-3 transition-all"
              style={{ boxShadow: "0 4px 0 #4F8E6A" }}
            >
              Suggest a feature
              <ArrowRight className="w-4 h-4" />
            </div>
          </div>

          {/* mascot with lightbulb */}
          <div className="relative hidden sm:flex items-center justify-center">
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 3.6, repeat: Infinity, ease: "easeInOut" }}
            >
              <ColyMascot size={150} mood="streak" withSparkles className="-rotate-[6deg]" />
            </motion.div>
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, type: "spring", stiffness: 200 }}
              className="absolute -top-2 -right-2 w-12 h-12 bg-coly-yellow rounded-full flex items-center justify-center"
              style={{ boxShadow: "0 4px 0 rgba(196,154,42,0.45)" }}
            >
              <Lightbulb className="w-6 h-6 text-coly-ink" fill="currentColor" />
            </motion.div>
          </div>
        </div>
      </motion.a>
    </div>
  </section>
);

export default FeatureSuggest;
